import script from "./DraftHistoricalProjectCard .vue?vue&type=script&lang=ts&setup=true"
export * from "./DraftHistoricalProjectCard .vue?vue&type=script&lang=ts&setup=true"

import "./DraftHistoricalProjectCard .vue?vue&type=style&index=0&id=0cb5b242&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb5b242"]])

export default __exports__